import * as React from 'react';
import { SVGProps } from 'react';

const Cart = (props: { color: string }) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 20c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 4 18c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 6 16c.55 0 1.02.196 1.412.587.392.392.588.863.588 1.413s-.196 1.021-.588 1.413A1.925 1.925 0 0 1 6 20Zm10 0c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 14 18c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 16 16c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413s-.196 1.021-.587 1.413A1.928 1.928 0 0 1 16 20ZM5.15 4l2.4 5h7l2.75-5H5.15ZM4.2 2h14.75c.383 0 .675.17.875.512.2.342.208.688.025 1.038l-3.55 6.4c-.183.333-.43.592-.738.775A1.943 1.943 0 0 1 14.55 11H7.1L6 13h12v2H6c-.75 0-1.317-.33-1.7-.988-.383-.658-.4-1.312-.05-1.962L5.6 9.6 2 2H0V0h3.25l.95 2Zm3.35 7h7-7Z"
      fill={props.color}
    />
  </svg>
);

export default Cart;
